// extracted by mini-css-extract-plugin
var _1 = "styles-module__link___G6KtK";
export { _1 as "link" }
